import { InfoOutline } from "@mui/icons-material";
import { Box, Button, Card, CardContent, IconButton, Link, Typography,Tooltip } from "@mui/material";
import { useRef, useState } from "react";
import { format } from 'date-fns';

import { styled } from "@mui/material/styles";
import { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { useSnackbar } from "../common/SnackbarContext";

interface AddNewRulesProps {
  onUpload: () => Promise<boolean>;
}

const UploadRulebook: React.FC<AddNewRulesProps> = ({ onUpload }) => {
    const { showSnackbar } = useSnackbar();
  
  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
          <Tooltip {...props} arrow classes={{ popper: className }} />
        ))(({ theme }) => ({
          [`& .${tooltipClasses.arrow}`]: {
            color: theme.palette.common.black,
          },
          [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.black,
            maxWidth: 221,
            padding: "8px 12px",
            color:"#BFC1C2",
            fontSize:'12px',
            fontWeight:400,
            fontFamily:'Inter',
            border:'1px solid #343333'
          },
        }));
  const [filesInfo, setFilesInfo] = useState([
    { name: '', date: '' },
    { name: '', date: '' },
    { name: '', date: '' }
  ]);
  
  const handleInputClick = (index:number) =>(event:any) => {
    // Reset the input value to allow selecting the same file
    event.target.value = null; 
  };

  const handleOnChange = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if(undefined == file) {
       const newFilesInfo = [...filesInfo];
        newFilesInfo[index] = {
          name: "",
          date: ""
        };
      setFilesInfo(newFilesInfo);
    }
   

    if (file) {
      if(filesInfo[index].name != "") {
        showSnackbar(`Previous file was replaced by ${file.name}`,"success");
      }
      
      const newFilesInfo = [...filesInfo];
      newFilesInfo[index] = {
        name: file.name,
        date: format(new Date(), 'yyyy-MM-dd h:mm a')
      };
      setFilesInfo(newFilesInfo);
      
    }
  };

  return (
    <div className="rules-upload-div">
      <div className="upload-block">
        <label className="div-txt-heading">Add New Rulebook</label>
        <label className="div-txt-sub-heading">
          Upload rulebook to add rules to the database. Note: Adding a new rulebook will replace the current active version.
        </label>
        <div>
          <Card className="upload-card" sx={{ borderRadius: '16px'}}>
            <CardContent sx={{ padding: '12px 20px !important', display: "flex" }}>
              <img src="/icons/rules_prorities.svg" alt="Rules" className="upload-card-icon" />
              <div className="content-div-upload flex-3">
                <div className="flex space-between ">
                  <div className="flex ">
                    <label className="upload-card-heading"> Rules and Priorities <span className="required-field">*</span></label>
                    <BootstrapTooltip title="Upload payroll validation rules and instructions. Ensure each rule is clear and self-explanatory. (Sample file provided for reference)">
                      <IconButton
                        color="primary"
                        size="small" sx={{pt:0}}
                      ><InfoOutline className="upload-card-info" />
                      </IconButton>
                    </BootstrapTooltip>
                    
                  </div>
                  <Link href="/sample-data/Rules_Priority_Sample.xlsx" underline="always" className="sample-link">
                    Sample Data
                  </Link>
                </div>
                <div>
                  <Typography variant="body2" className="upload-card-upload-dt">
                    Last Uploaded : {filesInfo[0].date || '--'}
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <Button
                      component="label"
                      variant="outlined"
                      sx={{
                        borderStyle: "dashed",
                        borderColor: "#007CB0",
                        color: "#007CB0",
                        textTransform: 'none',
                        marginRight: '13px'
                      }}
                    >
                      Choose file
                      <input
                        type="file"
                        accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        id="rulespriorities"
                        name="rulespriorities"
                        hidden
                        onChange={handleOnChange(0)}
                        onClick={handleInputClick(0)}
                      />
                    </Button>
                    <Typography sx={{ color: '#BDBDBD', fontStyle: 'italic', fontSize: '13px', fontWeight: '400' }}>
                      {filesInfo[0].name || "No File Chosen"}
                    </Typography>
                  </Box>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="upload-card" sx={{ borderRadius: '16px'}}>
            <CardContent sx={{ padding: '12px 20px !important',  display: "flex" }}>
              <img src="/icons/wagetypedescp.svg" alt="wage_type" className="upload-card-icon" />
              <div className="content-div-upload flex-3">
                <div className="flex space-between ">
                  <div className="flex ">
                    <label className="upload-card-heading"> Wage Type Description <span className="required-field">*</span></label>
                    <BootstrapTooltip title="Upload wage type codes and their short descriptions. Ensure the list is complete and current. (Sample file provided for reference)">
                      <IconButton
                        color="primary"
                        size="small" sx={{pt:0}}
                      ><InfoOutline className="upload-card-info" />
                      </IconButton>
                    </BootstrapTooltip>
                  </div>
                  <Link href="/sample-data/WT_Sample.xlsx" underline="always" className="sample-link">
                    Sample Data
                  </Link>
                </div>
                <div>
                  <Typography variant="body2" className="upload-card-upload-dt">
                    Last Uploaded : {filesInfo[1].date || '--'}
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <Button
                      component="label"
                      variant="outlined"
                      sx={{
                        borderStyle: "dashed",
                        borderColor: "#007CB0",
                        color: "#007CB0",
                        textTransform: 'none',
                        marginRight: '13px'
                      }}
                    >
                      Choose file
                      <input
                        type="file"
                        accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        id="wagetype"
                        name="wagetype"
                        hidden
                        onChange={handleOnChange(1)}
                        onClick={handleInputClick(1)}
                      />
                    </Button>
                    <Typography sx={{ color: '#BDBDBD', fontStyle: 'italic', fontSize: '13px', fontWeight: '400' }}>
                      {filesInfo[1].name || "No File Chosen"}
                    </Typography>
                  </Box>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="upload-card" sx={{ borderRadius: '16px'}}>
            <CardContent sx={{ padding: '12px 20px !important', display: "flex" }}>
              <img src="/icons/schemaofpayroll.svg" alt="schema_payroll" className="upload-card-icon" />
              <div className="content-div-upload flex-3">
                <div className="flex space-between ">
                  <div className="flex ">
                    <label className="upload-card-heading"> Schema of Payroll Data <span className="required-field">*</span></label>
                    <BootstrapTooltip title="Describe payroll data columns and their meanings for accurate validation mapping. (Sample file provided for reference)">
                      <IconButton
                        color="primary"
                        size="small" sx={{pt:0}}
                      ><InfoOutline className="upload-card-info" />
                      </IconButton>
                    </BootstrapTooltip>
                  </div>
                  <Link href="/sample-data/Schema_Sample.xlsx" underline="always" className="sample-link">
                    Sample Data
                  </Link>
                </div>
                <div>
                  <Typography variant="body2" className="upload-card-upload-dt">
                    Last Uploaded : {filesInfo[2].date || '--'}
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <Button
                      component="label"
                      variant="outlined"
                      sx={{
                        borderStyle: "dashed",
                        borderColor: "#007CB0",
                        color: "#007CB0",
                        textTransform: 'none',
                        marginRight: '13px'
                      }}
                    >
                      Choose file
                      <input
                        type="file"
                        accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        id="payroll"
                        name="payroll"
                        hidden
                        onChange={handleOnChange(2)}
                        onClick={handleInputClick(2)}
                      />
                    </Button>
                    <Typography sx={{ color: '#BDBDBD', fontStyle: 'italic', fontSize: '13px', fontWeight: '400' }}>
                      {filesInfo[2].name || "No File Chosen"}
                    </Typography>
                  </Box>
                </div>
              </div>
            </CardContent>
          </Card>
          <div className="required-field" style={{ textAlign: 'right',paddingTop: '0.5em',fontSize:'13px', fontWeight:400}}>
                      * Mandatory upload
          </div >
        </div>
      </div>
    </div>
  );
};

export default UploadRulebook;
